import React, { useState } from 'react'
import { CircularProgress, Typography, withStyles } from '@material-ui/core'
import { Icon } from '@iconify/react'
import styles from './styles'
import clsx from 'clsx'
import { useDispatch } from 'react-redux'
import { aICreatorDeleteAttachmentAction } from 'src/reducers/ai-creator/action'
import { track } from '@amplitude/analytics-browser'
import { CoreButton } from '../core'
import { aICreatorUploadAttachmentSuccess } from 'src/reducers/ai-creator/action'
import {
  componentBoxShowAction,
  componentBoxHideAction,
} from 'src/reducers/component-box/action'
import ComponentBoxContent from 'src/model/component-box'
import RecentFiles from 'src/components/recent-files'

const AttachmentView = props => {
  const {
    classes,
    attachments,
    handleOnDropFile,
    fileInputRef,
    handleFileSelect,
    attachmentLoading,
  } = props
  const [isHovered, setIsHovered] = useState(false)
  const [hoveredIconId, setHoveredIconId] = useState(null)
  const dispatch = useDispatch()

  const handleDeleteAttachment = attachmentId => {
    track('delete_attachment')
    dispatch(aICreatorDeleteAttachmentAction(attachmentId))
  }

  const onClickAttachment = () => {
    if (attachmentLoading) return
    fileInputRef.current.click()
  }
  const getRecentFile = () => {
    /**
     *
     * @param {} items
     */
    const selectRecentFiles = item => {
      dispatch(aICreatorUploadAttachmentSuccess(item, item.original_file_name))
      dispatch(componentBoxHideAction())
    }
    dispatch(
      componentBoxShowAction(
        new ComponentBoxContent(
          <RecentFiles selectRecentFiles={selectRecentFiles} />,
          {
            hideCloseButton: false,
          },
        ),
      ),
    )
  }

  return (
    <div className={classes.container}>
      <Typography className={classes.uploadedText}>Uploaded Files</Typography>
      {attachments.map((attachment, index) => (
        <div key={index} className={classes.attachmentRow}>
          <Icon
            icon="lets-icons:file-fill"
            className={clsx(classes.fileIcon, {
              [classes.fileIconError]: attachment.succeeded === false,
              [classes.fileIconSuccess]: attachment.succeeded === true,
            })}
          />
          <Typography className={classes.fileName}>
            {attachment.file_name}
          </Typography>
          <div className={classes.flexGrow} />
          {attachment.succeeded === false &&
          attachment.upload_status !== 'failed' &&
          attachment.upload_status !== 'partial_failure' &&
          !(attachment.error_details && attachment.error_details.length > 0) ? (
            <CircularProgress
              size="16px"
              color="primary"
              className={classes.circularProgress}
            />
          ) : (
            <div
              onMouseEnter={() => setHoveredIconId(attachment.attachment_id)}
              onMouseLeave={() => setHoveredIconId(null)}
            >
              {hoveredIconId === attachment.attachment_id ||
              attachment.succeeded === false ? (
                <Icon
                  icon="iconamoon:close-light"
                  className={classes.closeIcon}
                  onClick={() =>
                    handleDeleteAttachment(attachment.attachment_id)
                  }
                />
              ) : (
                <Icon icon="charm:tick" className={classes.tickIcon} />
              )}
            </div>
          )}
        </div>
      ))}

      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onDrop={handleOnDropFile}
        onDragOver={e => e.preventDefault()}
        className={classes.addMore}
      >
        {attachmentLoading ? (
          <CircularProgress size={20} />
        ) : (
          <>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: 'none' }}
              accept=".pdf,.txt"
              onChange={handleFileSelect}
            />
            <Icon icon="f7:cloud-upload" className={classes.iconDefault} />
            <Typography className={classes.textHovered}>
              Add another file
            </Typography>
            <div className={classes.flexGrow} />
            <CoreButton variant="outlined" color="dark" onClick={getRecentFile}>
              Select recent file
            </CoreButton>
            <CoreButton variant="text" color="dark" onClick={onClickAttachment}>
              Upload
            </CoreButton>
          </>
        )}
      </div>
    </div>
  )
}

export default withStyles(styles)(AttachmentView)
